export function MonogramBadge({ className }: Readonly<{ className?: string }>) {
  return (
    <div
      className={`flex size-12 items-center justify-center rounded-xl bg-white text-foreground shadow-md ring-4 ring-white/20 ${className ?? ''}`}
    >
      <span className="text-lg font-bold tracking-tight">🌿</span>
    </div>
  );
}
